import { FETCH_ALL_TECHNICIANS_ERROR, FETCH_ALL_TECHNICIANS_START, FETCH_ALL_TECHNICIANS_SUCCESS } from "../../actions/receptionist/techniciansAction";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    technicians: []
};

const techniciansReducer = (state = INIT_STATE, action) => {

    switch (action.type) {
        case FETCH_ALL_TECHNICIANS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_ALL_TECHNICIANS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, technicians: [...action.technicians] };

        }
        case FETCH_ALL_TECHNICIANS_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}

export default techniciansReducer;